/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Medialibrarytoolqr3Inputs */

const en_medialibrarytoolqr3 = /** @type {(inputs: Medialibrarytoolqr3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`QR code`)
};

const de_medialibrarytoolqr3 = /** @type {(inputs: Medialibrarytoolqr3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`QR-Code`)
};

/**
* | output |
* | --- |
* | "QR code" |
*
* @param {Medialibrarytoolqr3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const medialibrarytoolqr3 = /** @type {((inputs?: Medialibrarytoolqr3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Medialibrarytoolqr3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_medialibrarytoolqr3(inputs)
	return de_medialibrarytoolqr3(inputs)
});
export { medialibrarytoolqr3 as "mediaLibraryToolQr" }